import { GA4_STANDARD_PROPERTIES, ALLOWED_CUSTOM_PROPERTIES, ALLOWED_CUSTOM_PROPERTY_PREFIXES } from '../data-layer/config.js';

/**
 * Bereitet ein `ga4DataLayer`-Event für den Versand auf — unabhängig davon, ob
 * es anschließend per gtag oder über die native Firebase-Bridge rausgeht.
 *
 * Bei E-Commerce-Events liegen items/value/currency etc. unter `ecommerce`,
 * andere Properties (UTMs, Custom Dimensions, …) auf dem Top-Level. Beide
 * Quellen werden gefiltert und flach gemerged, weil weder gtag noch das
 * Firebase-SDK einen `ecommerce`-Wrapper kennen.
 *
 * @param {Object} eventObject Event aus dem `ga4DataLayer`
 * @returns {{eventName: string, params: Object}}
 */
export function buildEventParams(eventObject) {
    const { event, ecommerce, ...topLevelProps } = eventObject;
    const filteredTopLevel = filterAllowedProperties(topLevelProps);
    const filteredEcommerce = filterAllowedProperties(ecommerce);

    const params = {
        ...filteredTopLevel,
        ...filteredEcommerce
    };

    return {
        eventName: event,
        params: params
    };
}

/**
 * Behält nur Properties, die in einer der beiden Allowlists stehen.
 *
 * @param {Object} params
 * @returns {Object}
 */
export function filterAllowedProperties(params) {
    if (!params || typeof params !== 'object') {
        return {};
    }

    const filtered = {};
    for (const [key, value] of Object.entries(params)) {
        if (isAllowedProperty(key)) {
            filtered[key] = value;
        }
    }
    return filtered;
}

function isAllowedProperty(key) {
    if (GA4_STANDARD_PROPERTIES.includes(key)) {
        return true;
    }
    if (ALLOWED_CUSTOM_PROPERTIES.includes(key)) {
        return true;
    }
    return hasAllowedPrefix(key);
}

function hasAllowedPrefix(key) {
    if (typeof key !== 'string') {
        return false;
    }

    for (const prefix of ALLOWED_CUSTOM_PROPERTY_PREFIXES) {
        if (key.startsWith(prefix)) {
            return true;
        }
    }
    return false;
}
